import { Component, OnInit } from "@angular/core";
import { LoadingController, NavParams } from "ionic-angular";
import { ViewController } from "ionic-angular/navigation/view-controller";
import { UserState } from "../../app/store/reducers/user.reducer";
import { compare } from "fast-json-patch";
import {
  EventLoggingService,
  LogEventId
} from "../../app/services/event-logging.service";
import { FhirService } from "../../app/services/fhir.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { AppState } from "../../app/models/app.state";
import { DiaprofilPatient } from "../../app/models/diaprofil-patient";
import { DiaprofilProTask } from "../../app/models/diaprofil-pro-task";
import * as FhirActions from "../../app/store/actions/fhir.actions";
import {
  IConsultationStatusDetails,
  QNR_RESPONSE_CONSULTATION_STATUS_EXT_URL
} from "../../app/models/types";
import { DiaProfilService } from "../../app/services/diaprofil.service";

@Component({
  selector: "consultation-status-modal",
  templateUrl: "consultation-status.modal.html"
})
export class ConsultationStatusModal implements OnInit {
  userState: UserState;
  form: FormGroup = null;
  patient: DiaprofilPatient;
  proTask: DiaprofilProTask;
  public consultationStatus: IConsultationStatusDetails = null;
  public ffPartialConsultationCompletion = "DISABLED";
  public ffNoShowEboksNotificationEnabled = false;
  constructor(
    private store: Store<AppState>,
    private viewCtrl: ViewController,
    private navParams: NavParams,
    private eventLogging: EventLoggingService,
    private fhir: FhirService,
    private loadingCtrl: LoadingController,
    private fb: FormBuilder,
    public diaprofilService: DiaProfilService
  ) {}

  ngOnInit() {
    this.userState = this.navParams.get("userState");
    this.patient = this.navParams.get("patient");
    this.proTask = this.navParams.get("proTask");
    this.consultationStatus = this.proTask.consultationStatus;
    this.ffPartialConsultationCompletion = this.diaprofilService.configState.ffPartialConsultationCompletion;
    this.ffNoShowEboksNotificationEnabled = this.diaprofilService.configState.ffNoShowEboksNotificationEnabled;
    this.form = this.fb.group({
      status: [
        this.consultationStatus.status,
        Validators.compose([Validators.required])
      ],
      comment: this.consultationStatus.comment
    });
  }

  dismiss($event) {
    this.viewCtrl.dismiss(this.proTask);
  }

  save() {
    const loading = this.loadingCtrl.create({
      content: "Gemmer",
      dismissOnPageChange: true
    });
    loading.present();
    const data = this.form.value;
    const patch = this.addConsultationCompletedExt(data); // data is the selected consultation type
    patch.request.subscribe(result => {
      this.proTask.response = patch.new;
      this.store.dispatch(new FhirActions.ReplaceAction(patch.new));
      this.eventLogging.saveEvent({
        event_id: LogEventId.COMPLETE_PATIENT_CONSULTATION,
        event_src_location: "DashboardPage",
        patient_fhir_id: this.patient.fhirId,
        patient_full_name: this.patient.fullName,
        parent_task_uuid: this.proTask.task.id,
        qnr_response_uuid: this.proTask.response.id
      });
      loading.dismiss();
      this.viewCtrl.dismiss(this.proTask);
    });
  }

  addConsultationCompletedExt(props: {
    status:
      | "COMPLETED_WITH_PATIENT"
      | "PARTIALLY_COMPLETED"
      | "PATIENT_FAILED_TO_APPEAR";
    comment: string;
    consultationMedia?:
      | "PHYSICAL_CONSULTATION"
      | "VIDEO_CONSULTATION_NO_SCREEN_SHARING"
      | "VIDEO_CONSULTATION_WITH_SCREEN_SHARING"
      | "PHONE_CONSULTATION";
  }) {
    const newVersion = { ...{}, ...this.proTask.response };
    if (!newVersion.hasOwnProperty("extension")) {
      newVersion.extension = [];
    }
    const ext: fhir.Extension = {
      url: QNR_RESPONSE_CONSULTATION_STATUS_EXT_URL,
      valueBoolean: props.status === "PATIENT_FAILED_TO_APPEAR" ? false : true,
      extension: [
        {
          url: "hcp",
          valueReference: {
            reference: `Practitioner/${this.userState.userFhir.id}`,
            display: this.userState.userInitials
          }
        },
        {
          url: "dateTime",
          valueDateTime: new Date().toISOString()
        },
        {
          url: "status",
          valueCode: props.status
        },
        {
          url: "media",
          valueCode: props.consultationMedia
            ? props.consultationMedia
            : "NOT_ANSWERED"
        },
        {
          url: "comment",
          valueString: props.comment
        }
      ]
    };
    newVersion.extension = [
      ...newVersion.extension.filter(
        existing => existing.url !== QNR_RESPONSE_CONSULTATION_STATUS_EXT_URL
      ),
      ext
    ];
    console.log(newVersion.extension);
    const patchContent = compare(this.proTask.response, newVersion);
    return {
      request: this.fhir.patchResource({
        resourceType: "QuestionnaireResponse",
        resourceId: this.proTask.response.id,
        operations: patchContent
      }),
      new: newVersion
    };
  }
}



// WEBPACK FOOTER //
// ./src/modals/consultation-status.modal/consultation-status.modal.ts